import { useState, useEffect } from 'react'
import { getZealysLogins } from '../services/internal-access-api'
import type { ZealysLogin } from '../types/internal-access.types'

interface UseZealysLoginsResult {
  logins: ZealysLogin[]
  loading: boolean
  error: Error | null
  refresh: () => Promise<void>
}

export function useZealysLogins(): UseZealysLoginsResult {
  const [logins, setLogins] = useState<ZealysLogin[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)

  const fetchLogins = async () => {
    try {
      setLoading(true)
      setError(null)
      const data = await getZealysLogins()
      setLogins(data)
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to fetch logins'))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchLogins()
  }, [])

  return {
    logins,
    loading,
    error,
    refresh: fetchLogins
  }
}
